export const findPageNumberOfModel = (items, targetId, itemsPerPage, field = 'id') => {
    const itemIndex = items.findIndex((item) => item[field] === targetId);
    if (itemIndex === -1) {
        return -1; // Item not found
    }
    return Math.floor(itemIndex / itemsPerPage) + 1;
};
